/**
 * Profile feature constants — tabs and empty-state copy. Mirrors the shape
 * used by sibling features (bookshelf/communities/myWriting constants).
 */

export const PROFILE_TABS = [
  { key: 'overview', label: 'Overview' },
  { key: 'bookshelf', label: 'Bookshelf' },
  { key: 'scribbles', label: 'Scribbles' },
  { key: 'writing', label: 'Writing' },
  { key: 'communities', label: 'Communities' },
];

export const EMPTY_STATE_MESSAGES = {
  currentlyReading: {
    heading: 'Nothing on the nightstand yet',
    subheading: 'Pick up a book and it will show up here, right where you left off.',
    cta: 'Find something to read',
  },
  favorites: {
    heading: 'No favorites marked yet',
    subheading: 'Heart the books that shaped you — they belong front and center.',
    cta: 'Browse your shelf',
  },
  recentlyRead: {
    heading: 'Your reading story starts here',
    subheading: 'Find a book that deserves a place on your shelf.',
    cta: 'Discover books',
  },
  tbr: {
    heading: 'An empty to-be-read pile',
    subheading: "Add a few titles you're curious about — future you will thank you.",
    cta: 'Add to your TBR',
  },
  scribbles: {
    heading: 'Every reader has something to say',
    subheading: 'Turn a favorite line or a lingering thought into your first scribble.',
    cta: 'Write your first scribble',
  },
  writing: {
    heading: 'Every story starts as an idea',
    subheading: 'Publish a manuscript and it will appear here for the world to read.',
    cta: 'Start writing',
  },
  communities: {
    heading: "You haven't joined a community yet",
    subheading: 'Find readers and writers who love what you love.',
    cta: 'Explore communities',
  },
};
